import { render, staticRenderFns } from "./GhostwritingDashboard.vue?vue&type=template&id=86522d14&"
import script from "./GhostwritingDashboard.vue?vue&type=script&lang=js&"
export * from "./GhostwritingDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports